import { Injectable } from "@angular/core";
import { IID_OL_OLOREQUEST } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolOloRequestStore } from "./iidOlOloRequest.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.OLO_REQUEST)
export class IIDolOloRequestQuery extends AbstractInterfaceDataQuery<IID_OL_OLOREQUEST> {
  constructor(protected store: IIDolOloRequestStore) {
    super(store);
  }
}
